import type { CalendarEvent, ContactPayload, SiteContent } from '../types'

// Empty in dev (Vite proxies /api → .NET gateway); set VITE_API_BASE_URL in prod.
const BASE = import.meta.env.VITE_API_BASE_URL ?? ''

async function getJson<T>(path: string, signal?: AbortSignal): Promise<T> {
  const res = await fetch(`${BASE}${path}`, { headers: { Accept: 'application/json' }, signal })
  if (!res.ok) throw new Error(`GET ${path} → ${res.status}`)
  return res.json() as Promise<T>
}

export const fetchEvents = (signal?: AbortSignal) =>
  getJson<CalendarEvent[]>('/api/events', signal)

/** All CMS-managed copy, imagery and contact details for the page. */
export const fetchContent = (signal?: AbortSignal) =>
  getJson<SiteContent>('/api/content', signal)

export async function submitContact(payload: ContactPayload): Promise<void> {
  const res = await fetch(`${BASE}/api/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!res.ok) {
    const detail = await res.text().catch(() => '')
    throw new Error(detail || `POST /api/contact → ${res.status}`)
  }
}
